import React, { useState } from 'react';

const PasswordInput = ({ onSuccess }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const correctPassword = '02534';

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password === correctPassword) {
      setError('');
      onSuccess(); // сообщаем родителю, что авторизация прошла
    } else {
      setError('Не верный пароль');
    }
  };

  return (
    <form onSubmit={handleSubmit} className='system-form'>
      <div className='system-input-box d-flex'>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Введите пароль"
        />
        <button type="submit" className="system-booking-table-btn system-booking-table-btn-edit">Открыть</button>
      </div>
        {error && <p style={{ color: 'red' }}>{error}</p>}
    </form>
  );
};

export default PasswordInput;
